var _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackground2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 909,
    height: 672,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 454.365,
    cy: 168.59,
    fill: "#fff",
    rx: 433.444,
    ry: 256.092,
    transform: "rotate(-56.086 454.365 168.59)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground2);
export default __webpack_public_path__ + "static/media/background2.98c062db763bcb640c14f40aa0b75709.svg";
export { ForwardRef as ReactComponent };